import React from "react";
import OutletModel from "../models/outlet_model";
import Select from "react-select";

type Props = {
    outletOptions: OutletModel[];
    selectedOutletsMap: Map<number, OutletModel>;
    onToggleOutlet: (outlet: OutletModel) => void;
};

export default class OutletSelectionToggleWidget extends React.Component<Props> {
    render(): React.ReactNode {
        const { outletOptions, selectedOutletsMap, onToggleOutlet } =
            this.props;

        return (
            <>
                <label className="block text-white font-medium mb-2">
                    Outlet Terpilih :
                </label>
                {/* Selected Outlets */}
                {selectedOutletsMap.size > 0 && (
                    <div className="flex flex-wrap gap-3 mb-4">
                        {[...selectedOutletsMap.values()].map((outlet) => (
                            <div
                                key={outlet.id}
                                className="flex items-center bg-white text-black px-4 py-2 rounded-lg shadow cursor-pointer hover:bg-red-100 transition"
                                onClick={() => onToggleOutlet(outlet)}
                            >
                                {outlet.name}
                                <span className="ml-2 text-red-500 font-bold">
                                    ×
                                </span>
                            </div>
                        ))}
                    </div>
                )}

                {/* React-Select Dropdown */}
                <div>
                    <label className="block text-white font-medium mb-2">
                        Tambahkan Outlet
                    </label>
                    <Select
                        options={outletOptions.map((outlet) => ({
                            value: outlet,
                            label: outlet.name,
                        }))}
                        onChange={(selected) => {
                            if (selected) {
                                onToggleOutlet(selected.value);
                            }
                        }}
                        placeholder="Pilih outlet untuk menambahkan"
                        isSearchable
                    />
                </div>
            </>
        );
    }
}
